import { Typography, useMediaQuery, useTheme } from "@mui/material";

const images: { src: string; alt: string; cols?: number }[] = [
  {
    src: "/images/Motivators.png",
    alt: "Motivators",
  },
  {
    src: "/images/Identities.png",
    alt: "Identities",
  },
  {
    src: "/images/Report.png",
    alt: "Report",
  },
];

const AssessmentDetails = () => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.only("md"));
  const isLarge = useMediaQuery(theme.breakpoints.only("lg"));

  const [cols, height] = (() => {
    if (isLarge) return [2.75, 600];
    if (isMedium) return [3.5, 400];
    return [3, 200];
  })();
  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        align="center"
        style={{ marginTop: theme.spacing(4) }}
      >
        See what&apos;s inside...
      </Typography>
      <div
        style={{
          overflowX: "scroll",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 16,
          }}
        >
          {images.map(({ src, alt }) => (
            <img key={src} src={src} alt={alt} loading="lazy" height={height} />
          ))}
        </div>
      </div>
    </>
  );
};

export default AssessmentDetails;
